import React, { FC } from "react";
import { WebSubscriptionDto } from "./WebSubscription";
import { IconButton, ListItem, ListItemText, Stack } from "@mui/material";
import { UAParser } from "ua-parser-js";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
export interface SubscriptionItemProps {
  subscription: WebSubscriptionDto;
  onRemove: (subscription: WebSubscriptionDto) => void;
}

export const SubscriptionItem: FC<SubscriptionItemProps> = (props) => {
  const { device, os, browser, engine } = UAParser(
    props.subscription.userAgent
  );
  return (
    <ListItem>
      <ListItemText>
        <Stack direction={"row"} useFlexGap gap={1}>
          {device.model} / {os.name} / {browser.name}{" "}
          <IconButton onClick={() => props.onRemove(props.subscription)}>
            <RemoveRoundedIcon />
          </IconButton>
        </Stack>
      </ListItemText>
    </ListItem>
  );
};
